import store from '../store'
// import Pusher from 'pusher-js'
// import config from '../../config/config.json'
import eventBus from '../../services/event-bus'
import User from '../../models/user'

export default{
  namespaced: true,
  state: {
    user: null,
    username: null,
    token: null
  },
  getters: {
    authenticated: (state) => state.token !== null,
    credentials: (state) => {
      return {
        'username': state.username,
        'token': state.token
      }
    },
    token: (state) => state.token,
    username: (state) => state.username,
    user: (state) => User.fromJson(state.user)
  },
  mutations: {
    SET_USER (state, user) {
      state.user = user
    },
    SET_USERNAME (state, username) {
      state.username = username
    },
    SET_TOKEN (state, token) {
      state.token = token
    },
    CLEAR_USERNAME (state) {
      state.username = null
    },
    CLEAR_TOKEN (state) {
      state.token = null
    }
  },
  actions: {
    async login ({ commit }, credentials) {
      try {
        const response = await this.$api.login(credentials)
        commit('SET_USERNAME', credentials.username)
        commit('SET_TOKEN', response.token.token)
        commit('SET_USER', response.user)
        this.$api.setCredentials({
          username: credentials.username,
          token: response.token.token
        })
        eventBus.$emit('authenticated', store.getters['auth/credentials'])
        /**
        this.$pusher = new Pusher(config.pusher.appKey, {
          cluster: config.pusher.cluster,
          channelAuthorization: {
            endpoint: `${config.uri}?r=pusher/auth&token=${store.getters['auth/token']}`
          }
        })
        this.$pusher.subscribe(`private-user.${credentials.username}`)
        this.$pusher.subscribe('private-role.screen')
        **/
        return 200
      } catch (e) {
        return e
      }
    },
    logout ({commit}) {
      commit('CLEAR_USERNAME')
      commit('CLEAR_TOKEN')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js